var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var UiFileUploadWidget = function () {
            function UiFileUploadWidget(root) {
                _classCallCheck(this, UiFileUploadWidget);

                this.root = root;
                this.input = root.querySelector('[data-ui-file-upload-input]');
                this.trigger = root.querySelector('[data-ui-file-upload-trigger]');
                this.list = root.querySelector('[data-ui-file-upload-list]');
                this.error = root.querySelector('[data-ui-file-upload-error]');
                this.template = root.querySelector('[data-ui-file-upload-template]');
                this.files = [];
                this.previewUrls = [];
                this.maxFileSize = Number(root.dataset.uiFileUploadMaxSize || 0);
                this.invalidTypeMessage = root.dataset.uiFileUploadInvalidTypeMessage || '';
                this.maxSizeMessage = root.dataset.uiFileUploadMaxSizeMessage || '';

                this.bindEvents();
            }

            _createClass(UiFileUploadWidget, [{
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;

                    if (this.trigger && this.input) {
                        this.trigger.addEventListener('click', function () {
                            _this.input.click();
                        });
                    }

                    if (this.input) {
                        this.input.addEventListener('change', function () {
                            _this.addFiles(Array.from(_this.input.files || []));
                        });
                    }
                }
            }, {
                key: "addFiles",
                value: function addFiles(files) {
                    var _this2 = this;

                    if (!files.length) {
                        return;
                    }

                    this.clearError();

                    var validFiles = files.filter(function (file) {
                        return _this2.validateFile(file);
                    });

                    if (!validFiles.length) {
                        this.syncInputFiles();
                        this.dispatchChange();
                        return;
                    }

                    if (this.input && !this.input.multiple) {
                        this.files = validFiles.slice(0, 1);
                    } else {
                        this.files = this.files.concat(validFiles);
                    }

                    this.syncInputFiles();
                    this.render();
                    this.dispatchChange();
                }
            }, {
                key: "removeFile",
                value: function removeFile(index) {
                    this.files.splice(index, 1);
                    this.syncInputFiles();
                    this.render();
                    this.dispatchChange();
                }
            }, {
                key: "syncInputFiles",
                value: function syncInputFiles() {
                    if (!this.input || typeof DataTransfer === 'undefined') {
                        return;
                    }

                    var dataTransfer = new DataTransfer();

                    this.files.forEach(function (file) {
                        dataTransfer.items.add(file);
                    });

                    this.input.files = dataTransfer.files;
                }
            }, {
                key: "render",
                value: function render() {
                    var _this3 = this;

                    if (!this.list || !this.template) {
                        return;
                    }

                    this.revokePreviewUrls();
                    this.list.innerHTML = '';
                    this.list.classList.toggle('ui-file-upload__list_empty', this.files.length === 0);

                    this.files.forEach(function (file, index) {
                        var item = _this3.template.content.firstElementChild.cloneNode(true);
                        var name = item.querySelector('[data-ui-file-upload-file-name]');
                        var preview = item.querySelector('[data-ui-file-upload-file-preview]');
                        var remove = item.querySelector('[data-ui-file-upload-remove]');
                        var isImage = file.type.indexOf('image/') === 0;

                        item.classList.toggle('ui-file-upload__item_image', isImage);

                        if (name) {
                            name.textContent = file.name;
                            name.title = file.name;
                        }

                        if (preview && isImage) {
                            var previewUrl = URL.createObjectURL(file);
                            preview.src = previewUrl;
                            _this3.previewUrls.push(previewUrl);
                        }

                        if (remove) {
                            remove.addEventListener('click', function () {
                                _this3.removeFile(index);
                            });
                        }

                        _this3.list.appendChild(item);
                    });
                }
            }, {
                key: "validateFile",
                value: function validateFile(file) {
                    if (!this.isAllowedType(file)) {
                        this.showError(this.invalidTypeMessage);
                        return false;
                    }

                    if (this.maxFileSize > 0 && file.size > this.maxFileSize) {
                        this.showError(this.maxSizeMessage);
                        return false;
                    }

                    return true;
                }
            }, {
                key: "isAllowedType",
                value: function isAllowedType(file) {
                    var fileName = file.name.toLowerCase();

                    return file.type.indexOf('image/') === 0 || file.type.indexOf('video/') === 0 || file.type === 'application/pdf' || fileName.endsWith('.pdf');
                }
            }, {
                key: "showError",
                value: function showError(message) {
                    if (!this.error) {
                        return;
                    }

                    this.error.textContent = message;
                    this.error.classList.add('ui-file-upload__error_visible');
                }
            }, {
                key: "clearError",
                value: function clearError() {
                    if (!this.error) {
                        return;
                    }

                    this.error.textContent = '';
                    this.error.classList.remove('ui-file-upload__error_visible');
                }
            }, {
                key: "revokePreviewUrls",
                value: function revokePreviewUrls() {
                    this.previewUrls.forEach(function (previewUrl) {
                        URL.revokeObjectURL(previewUrl);
                    });

                    this.previewUrls = [];
                }
            }, {
                key: "dispatchChange",
                value: function dispatchChange() {
                    this.root.dispatchEvent(new CustomEvent('ui-file-upload:change', {
                        bubbles: true,
                        detail: {
                            files: this.files.slice()
                        }
                    }));
                }
            }]);

            return UiFileUploadWidget;
        }();

        function initUiFileUploadWidgets() {
            document.querySelectorAll('[data-ui-file-upload]').forEach(function (root) {
                if (root.uiFileUploadWidget) {
                    return;
                }

                root.uiFileUploadWidget = new UiFileUploadWidget(root);
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initUiFileUploadWidgets);
        } else {
            initUiFileUploadWidgets();
        }

        window.UiFileUploadWidget = UiFileUploadWidget;
    }, {}] }, {}, [1]);